/* eslint-disable @typescript-eslint/ban-ts-comment */
import { forwardRef } from "react";
// @ts-ignore
import { IMaskInputProps } from "react-imask/dist/mixin";
import { FieldErrors, FieldValues } from "react-hook-form";
import  { FormInputLayout } from "./FormInputLayot";
import InputMask from "./InputMask";

type FormInputMaskProps = {
  name: string;
  label?: string;
  error?: FieldErrors<FieldValues> | string;
  showError?: boolean;
  classNameForm?: string;
  hasError?: boolean;
} & IMaskInputProps;

/**
 * @component
 * Компонент формы поля с маской
 * @example Пример для номера телефона mask={"+7 (000) 000-00-00"}
 * @description
 * Форма c маской, с label и отображением ошибки
 */

export const FormInputMask = forwardRef<HTMLInputElement, FormInputMaskProps>(
  (
    { name, label, error, showError = true, id, classNameForm, hasError, ...props },
    ref
  ) => {
    const errorState = showError && error;
    return (
      <FormInputLayout
        name={name}
        id={id}
        label={label}
        classNameForm={classNameForm}
        error={error}
        showError={showError}
      >
        <InputMask {...props} inputRef={ref} name={name} id={id ? id : name} hasError={hasError || errorState} />
      </FormInputLayout>
    );
  }
);

FormInputMask.displayName = "FormInputMask";